import { TranslatePipe } from '../../filters/translate.pipe';
import {Component, OnInit, inject, Input} from '@angular/core';
import { CommonModule } from '@angular/common';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import { RouterLink } from '@angular/router';
import AngularFilterHelperService from "../../services/angular-filter-helper.service";

@Component({
    standalone: true,
    selector: 'modal-selected-survey',
    templateUrl: './modal-selected-survey.component.html',
    imports: [CommonModule, TranslatePipe, RouterLink]
})
export class ModalSelectedSurveyComponent implements OnInit {
    private dialogRef = inject(MatDialogRef<ModalSelectedSurveyComponent>);
    private data = inject(MAT_DIALOG_DATA);

    private angularFilterHelperService: AngularFilterHelperService = inject(AngularFilterHelperService);

    vm: any = undefined;

    constructor() {
        this.vm = this;
    }

    ngOnInit() {
        Object.keys(this.data).forEach(key => this.vm[key] = this.data[key]);
        this.vm.close = this.close;
        let message = this.angularFilterHelperService.translate('Surveys.Survey_Selection_Step');

        document.getElementById('message').innerHTML = message.replace('%s', `<b>${this.vm.questionnaireName}</b>`);
    }


    close() {
        this.dialogRef.close(undefined);
    }

}